/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

export class JwtApiBase {
  AccessToken: Promise<string> | undefined

  protected readonly transformOptions = async (options: RequestInit): Promise<RequestInit> => {
    const token = await this.AccessToken

    options.headers = {
      ...options.headers,
      Authorization: `Bearer ${token}`,
    }

    return options
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  public readonly setAccessToken = (token: Promise<string>) => {
    this.AccessToken = token
  }
}

export interface IContentDeliveryClientV3 {

    /**
     * Get a list of all Room Metadata
     * @param companyId (optional) CompanyId to query to get a list of all Room Metadata for a given Company
     * @param contentMetadataId (optional) ContentMetadataId to query to get a list of all Room Metadata for a given ContentMetadata
     * @param releaseChannelId (optional) ReleaseChannelId to query to get a list of all Room Metadata for a given ReleaseChannel
     * @param search (optional) 
     * @param requireExistingRelease (optional) Should Room Metadata with no releases be ignored
     * @return List of RoomMetadata can be found in the body of the response.
     */
    getRoomMetadata(pageNumber: number, pageSize: number, companyId: string | undefined, contentMetadataId: string | undefined, releaseChannelId: string | undefined, search: string | undefined, requireExistingRelease: boolean | undefined): Promise<RoomMetadata[]>;

    /**
     * Create Room Metadata for a given Company
     * @return Room Metadata successfully created and can be found in the body of the response.
     */
    createRoomMetadata(body: RoomMetadataWithoutId): Promise<RoomMetadata>;

    /**
     * Update a single Room Metadata
     * @return Room Metadata successfully updated.
     */
    updateRoomMetadata(roomMetadataId: string, body: RoomMetadataWithoutId): Promise<void>;

    /**
     * Assign a Release (by ID) to a ReleaseChannel
     * @param releaseChannelId ID of ReleaseChannel
     * @return Release successfully assigned to this ReleaseChannel of the response
     */
    assignReleaseToReleaseChannel(releaseChannelId: string, body: string): Promise<void>;

    /**
     * Get all Contents for a specific ReleaseChannel.
     * @param contentTypes (optional) 
     * @return List of all Contents by ReleaseChannel
     */
    getContentsByReleaseChannelId(releaseChannelId: string, pageNumber: number, pageSize: number, contentTypes: string[] | undefined): Promise<Content[]>;

    /**
     * Search for Release Channels with filtering
     * @return List of Release Channels matching the search criteria
     */
    searchReleaseChannels(body: ReleaseChannelSearchRequest): Promise<ReleaseChannelWithUsersCount[]>;

    /**
     * Get all Release Channels accessible by a User
     * @param userId Id of the user
     * @return List of Release Channels accessible by the user
     */
    getUserReleaseChannels(userId: string, pageNumber: number, pageSize: number): Promise<ReleaseChannel[]>;

    /**
     * Get all Release Channels accessible by a User Group
     * @param userGroupId Id of the user group
     * @return List of Release Channels accessible by the user group
     */
    getUserGroupReleaseChannels(userGroupId: string, pageNumber: number, pageSize: number): Promise<ReleaseChannel[]>;

    /**
     * Get a list of all Room Metadata by a User Group
     * @param userGroupId Id of the user group
     * @param requirements (optional) 
     * @param search (optional) 
     * @return List of RoomMetadata can be found in the body of the response.
     */
    getUserGroupRooms(userGroupId: string, pageNumber: number, pageSize: number, requirements: ContentMetadataRequirements[] | undefined, search: string | undefined): Promise<RoomMetadataWithRequirements[]>;
}

export class ContentDeliveryClientV3 extends JwtApiBase implements IContentDeliveryClientV3 {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/v3";
    }

    /**
     * Get a list of all Room Metadata
     * @param companyId (optional) CompanyId to query to get a list of all Room Metadata for a given Company
     * @param contentMetadataId (optional) ContentMetadataId to query to get a list of all Room Metadata for a given ContentMetadata
     * @param releaseChannelId (optional) ReleaseChannelId to query to get a list of all Room Metadata for a given ReleaseChannel
     * @param search (optional) 
     * @param requireExistingRelease (optional) Should Room Metadata with no releases be ignored
     * @return List of RoomMetadata can be found in the body of the response.
     */
    getRoomMetadata(pageNumber: number, pageSize: number, companyId: string | undefined, contentMetadataId: string | undefined, releaseChannelId: string | undefined, search: string | undefined, requireExistingRelease: boolean | undefined): Promise<RoomMetadata[]> {
        let url_ = this.baseUrl + "/rooms?";
        if (pageNumber === undefined || pageNumber === null)
            throw new Error("The parameter 'pageNumber' must be defined and cannot be null.");
        else
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (contentMetadataId === null)
            throw new Error("The parameter 'contentMetadataId' cannot be null.");
        else if (contentMetadataId !== undefined)
            url_ += "contentMetadataId=" + encodeURIComponent("" + contentMetadataId) + "&";
        if (releaseChannelId === null)
            throw new Error("The parameter 'releaseChannelId' cannot be null.");
        else if (releaseChannelId !== undefined)
            url_ += "releaseChannelId=" + encodeURIComponent("" + releaseChannelId) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (requireExistingRelease === null)
            throw new Error("The parameter 'requireExistingRelease' cannot be null.");
        else if (requireExistingRelease !== undefined)
            url_ += "requireExistingRelease=" + encodeURIComponent("" + requireExistingRelease) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetRoomMetadata(_response);
        });
    }

    protected processGetRoomMetadata(response: Response): Promise<RoomMetadata[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RoomMetadata.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You don\'t have permission to retrieve this room metadata", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RoomMetadata[]>(<any>null);
    }

    /**
     * Create Room Metadata for a given Company
     * @return Room Metadata successfully created and can be found in the body of the response.
     */
    createRoomMetadata(body: RoomMetadataWithoutId): Promise<RoomMetadata> {
        let url_ = this.baseUrl + "/rooms";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateRoomMetadata(_response);
        });
    }

    protected processCreateRoomMetadata(response: Response): Promise<RoomMetadata> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = RoomMetadata.fromJS(resultData201);
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You do not have sufficient permissions to perform this action.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("No Company Library found for given identifier.", status, _responseText, _headers);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            return throwException("Room with the same MapPath and ReleaseChannelId already exists.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RoomMetadata>(<any>null);
    }

    /**
     * Update a single Room Metadata
     * @return Room Metadata successfully updated.
     */
    updateRoomMetadata(roomMetadataId: string, body: RoomMetadataWithoutId): Promise<void> {
        let url_ = this.baseUrl + "/rooms/{roomMetadataId}";
        if (roomMetadataId === undefined || roomMetadataId === null)
            throw new Error("The parameter 'roomMetadataId' must be defined.");
        url_ = url_.replace("{roomMetadataId}", encodeURIComponent("" + roomMetadataId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateRoomMetadata(_response);
        });
    }

    protected processUpdateRoomMetadata(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad Request. Failed to parse Room Metadata identifier", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You do not have sufficient permissions to perform this action.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("No Company Library or Room Metadata found for given ids.", status, _responseText, _headers);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            return throwException("Room with the same MapPath and ReleaseChannelId already exists.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Assign a Release (by ID) to a ReleaseChannel
     * @param releaseChannelId ID of ReleaseChannel
     * @return Release successfully assigned to this ReleaseChannel of the response
     */
    assignReleaseToReleaseChannel(releaseChannelId: string, body: string): Promise<void> {
        let url_ = this.baseUrl + "/release-channels/{releaseChannelId}/release";
        if (releaseChannelId === undefined || releaseChannelId === null)
            throw new Error("The parameter 'releaseChannelId' must be defined.");
        url_ = url_.replace("{releaseChannelId}", encodeURIComponent("" + releaseChannelId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAssignReleaseToReleaseChannel(_response);
        });
    }

    protected processAssignReleaseToReleaseChannel(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Release is not published", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Release belongs to another ContentMetadata, or \'Latest\' channel is being modified", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Release or ReleaseChannel was not found", status, _responseText, _headers);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            return throwException("Release is already assigned to this ReleaseChannel", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Get all Contents for a specific ReleaseChannel.
     * @param contentTypes (optional) 
     * @return List of all Contents by ReleaseChannel
     */
    getContentsByReleaseChannelId(releaseChannelId: string, pageNumber: number, pageSize: number, contentTypes: string[] | undefined): Promise<Content[]> {
        let url_ = this.baseUrl + "/release-channels/{releaseChannelId}/contents?";
        if (releaseChannelId === undefined || releaseChannelId === null)
            throw new Error("The parameter 'releaseChannelId' must be defined.");
        url_ = url_.replace("{releaseChannelId}", encodeURIComponent("" + releaseChannelId));
        if (pageNumber === undefined || pageNumber === null)
            throw new Error("The parameter 'pageNumber' must be defined and cannot be null.");
        else
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (contentTypes === null)
            throw new Error("The parameter 'contentTypes' cannot be null.");
        else if (contentTypes !== undefined)
            contentTypes && contentTypes.forEach(item => { url_ += "contentTypes=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetContentsByReleaseChannelId(_response);
        });
    }

    protected processGetContentsByReleaseChannelId(response: Response): Promise<Content[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Content.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Params were badly formed. More information in the body of the response.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Content[]>(<any>null);
    }

    /**
     * Search for Release Channels with filtering
     * @return List of Release Channels matching the search criteria
     */
    searchReleaseChannels(body: ReleaseChannelSearchRequest): Promise<ReleaseChannelWithUsersCount[]> {
        let url_ = this.baseUrl + "/release-channels/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearchReleaseChannels(_response);
        });
    }

    protected processSearchReleaseChannels(response: Response): Promise<ReleaseChannelWithUsersCount[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReleaseChannelWithUsersCount.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad Request. Invalid paging parameters or search criteria.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReleaseChannelWithUsersCount[]>(<any>null);
    }

    /**
     * Get all Release Channels accessible by a User
     * @param userId Id of the user
     * @return List of Release Channels accessible by the user
     */
    getUserReleaseChannels(userId: string, pageNumber: number, pageSize: number): Promise<ReleaseChannel[]> {
        let url_ = this.baseUrl + "/users/{userId}/release-channels?";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (pageNumber === undefined || pageNumber === null)
            throw new Error("The parameter 'pageNumber' must be defined and cannot be null.");
        else
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUserReleaseChannels(_response);
        });
    }

    protected processGetUserReleaseChannels(response: Response): Promise<ReleaseChannel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReleaseChannel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad Request. Invalid paging parameters.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReleaseChannel[]>(<any>null);
    }

    /**
     * Get all Release Channels accessible by a User Group
     * @param userGroupId Id of the user group
     * @return List of Release Channels accessible by the user group
     */
    getUserGroupReleaseChannels(userGroupId: string, pageNumber: number, pageSize: number): Promise<ReleaseChannel[]> {
        let url_ = this.baseUrl + "/user-groups/{userGroupId}/release-channels?";
        if (userGroupId === undefined || userGroupId === null)
            throw new Error("The parameter 'userGroupId' must be defined.");
        url_ = url_.replace("{userGroupId}", encodeURIComponent("" + userGroupId));
        if (pageNumber === undefined || pageNumber === null)
            throw new Error("The parameter 'pageNumber' must be defined and cannot be null.");
        else
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUserGroupReleaseChannels(_response);
        });
    }

    protected processGetUserGroupReleaseChannels(response: Response): Promise<ReleaseChannel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReleaseChannel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad Request. Invalid paging parameters.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReleaseChannel[]>(<any>null);
    }

    /**
     * Get a list of all Room Metadata by a User Group
     * @param userGroupId Id of the user group
     * @param requirements (optional) 
     * @param search (optional) 
     * @return List of RoomMetadata can be found in the body of the response.
     */
    getUserGroupRooms(userGroupId: string, pageNumber: number, pageSize: number, requirements: ContentMetadataRequirements[] | undefined, search: string | undefined): Promise<RoomMetadataWithRequirements[]> {
        let url_ = this.baseUrl + "/user-groups/{userGroupId}/rooms?";
        if (userGroupId === undefined || userGroupId === null)
            throw new Error("The parameter 'userGroupId' must be defined.");
        url_ = url_.replace("{userGroupId}", encodeURIComponent("" + userGroupId));
        if (pageNumber === undefined || pageNumber === null)
            throw new Error("The parameter 'pageNumber' must be defined and cannot be null.");
        else
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (requirements === null)
            throw new Error("The parameter 'requirements' cannot be null.");
        else if (requirements !== undefined)
            requirements && requirements.forEach(item => { url_ += "requirements=" + encodeURIComponent("" + item) + "&"; });
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUserGroupRooms(_response);
        });
    }

    protected processGetUserGroupRooms(response: Response): Promise<RoomMetadataWithRequirements[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RoomMetadataWithRequirements.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad Request. Invalid paging parameters.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You don\'t have permission to retrieve this room metadata. You must be an administrator.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RoomMetadataWithRequirements[]>(<any>null);
    }
}

export class RoomMetadataBase implements IRoomMetadataBase {
    releaseChannelId!: string;
    roomName!: string;
    mapPath!: string;
    description?: string;
    replayRecordingType!: ReplayRecordingType;
    maxVisibility!: VisibilityType;
    isSinglePlayer!: boolean;
    isVisibleInMenu!: boolean;
    isHub!: boolean;
    isAugmentedRealityCompatible!: boolean;
    isCreatableByExternalUsers!: boolean;
    allowUserFiles!: boolean;
    allowSinglePlayerMode!: boolean;
    maxUsers!: number;

    constructor(data?: IRoomMetadataBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.allowUserFiles = true;
            this.allowSinglePlayerMode = true;
            this.maxUsers = 20;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.releaseChannelId = _data["ReleaseChannelId"];
            this.roomName = _data["RoomName"];
            this.mapPath = _data["MapPath"];
            this.description = _data["Description"];
            this.replayRecordingType = _data["ReplayRecordingType"];
            this.maxVisibility = _data["MaxVisibility"];
            this.isSinglePlayer = _data["IsSinglePlayer"];
            this.isVisibleInMenu = _data["IsVisibleInMenu"];
            this.isHub = _data["IsHub"];
            this.isAugmentedRealityCompatible = _data["IsAugmentedRealityCompatible"];
            this.isCreatableByExternalUsers = _data["IsCreatableByExternalUsers"];
            this.allowUserFiles = _data["AllowUserFiles"] !== undefined ? _data["AllowUserFiles"] : true;
            this.allowSinglePlayerMode = _data["AllowSinglePlayerMode"] !== undefined ? _data["AllowSinglePlayerMode"] : true;
            this.maxUsers = _data["MaxUsers"] !== undefined ? _data["MaxUsers"] : 20;
        }
    }

    static fromJS(data: any): RoomMetadataBase {
        data = typeof data === 'object' ? data : {};
        let result = new RoomMetadataBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ReleaseChannelId"] = this.releaseChannelId;
        data["RoomName"] = this.roomName;
        data["MapPath"] = this.mapPath;
        data["Description"] = this.description;
        data["ReplayRecordingType"] = this.replayRecordingType;
        data["MaxVisibility"] = this.maxVisibility;
        data["IsSinglePlayer"] = this.isSinglePlayer;
        data["IsVisibleInMenu"] = this.isVisibleInMenu;
        data["IsHub"] = this.isHub;
        data["IsAugmentedRealityCompatible"] = this.isAugmentedRealityCompatible;
        data["IsCreatableByExternalUsers"] = this.isCreatableByExternalUsers;
        data["AllowUserFiles"] = this.allowUserFiles;
        data["AllowSinglePlayerMode"] = this.allowSinglePlayerMode;
        data["MaxUsers"] = this.maxUsers;
        return data;
    }
}

export interface IRoomMetadataBase {
    releaseChannelId: string;
    roomName: string;
    mapPath: string;
    description?: string;
    replayRecordingType: ReplayRecordingType;
    maxVisibility: VisibilityType;
    isSinglePlayer: boolean;
    isVisibleInMenu: boolean;
    isHub: boolean;
    isAugmentedRealityCompatible: boolean;
    isCreatableByExternalUsers: boolean;
    allowUserFiles: boolean;
    allowSinglePlayerMode: boolean;
    maxUsers: number;
}

export class RoomMetadata extends RoomMetadataBase implements IRoomMetadata {
    roomMetadataId!: string;
    releaseChannelName!: string;
    contentMetadataId!: string;
    companyId!: string;
    notificationIconUrl?: string;
    libraryCardUrl?: string;
    libraryHeroUrl?: string;

    constructor(data?: IRoomMetadata) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.roomMetadataId = _data["RoomMetadataId"];
            this.releaseChannelName = _data["ReleaseChannelName"];
            this.contentMetadataId = _data["ContentMetadataId"];
            this.companyId = _data["CompanyId"];
            this.notificationIconUrl = _data["NotificationIconUrl"];
            this.libraryCardUrl = _data["LibraryCardUrl"];
            this.libraryHeroUrl = _data["LibraryHeroUrl"];
        }
    }

    static fromJS(data: any): RoomMetadata {
        data = typeof data === 'object' ? data : {};
        let result = new RoomMetadata();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["RoomMetadataId"] = this.roomMetadataId;
        data["ReleaseChannelName"] = this.releaseChannelName;
        data["ContentMetadataId"] = this.contentMetadataId;
        data["CompanyId"] = this.companyId;
        data["NotificationIconUrl"] = this.notificationIconUrl;
        data["LibraryCardUrl"] = this.libraryCardUrl;
        data["LibraryHeroUrl"] = this.libraryHeroUrl;
        super.toJSON(data);
        return data;
    }
}

export interface IRoomMetadata extends IRoomMetadataBase {
    roomMetadataId: string;
    releaseChannelName: string;
    contentMetadataId: string;
    companyId: string;
    notificationIconUrl?: string;
    libraryCardUrl?: string;
    libraryHeroUrl?: string;
}

export class RoomMetadataWithoutId extends RoomMetadataBase implements IRoomMetadataWithoutId {
    notificationIcon?: string;
    libraryCard?: string;
    libraryHero?: string;

    constructor(data?: IRoomMetadataWithoutId) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.notificationIcon = _data["NotificationIcon"];
            this.libraryCard = _data["LibraryCard"];
            this.libraryHero = _data["LibraryHero"];
        }
    }

    static fromJS(data: any): RoomMetadataWithoutId {
        data = typeof data === 'object' ? data : {};
        let result = new RoomMetadataWithoutId();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["NotificationIcon"] = this.notificationIcon;
        data["LibraryCard"] = this.libraryCard;
        data["LibraryHero"] = this.libraryHero;
        super.toJSON(data);
        return data;
    }
}

export interface IRoomMetadataWithoutId extends IRoomMetadataBase {
    notificationIcon?: string;
    libraryCard?: string;
    libraryHero?: string;
}

export class RoomMetadataWithRequirements extends RoomMetadata implements IRoomMetadataWithRequirements {
    requirements!: ContentMetadataRequirements;

    constructor(data?: IRoomMetadataWithRequirements) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.requirements = _data["Requirements"];
        }
    }

    static fromJS(data: any): RoomMetadataWithRequirements {
        data = typeof data === 'object' ? data : {};
        let result = new RoomMetadataWithRequirements();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Requirements"] = this.requirements;
        super.toJSON(data);
        return data;
    }
}

export interface IRoomMetadataWithRequirements extends IRoomMetadata {
    requirements: ContentMetadataRequirements;
}

export enum ContentMetadataRequirements {
    Optional = "Optional",
    AutoQueue = "AutoQueue",
    Required = "Required",
}

export class Content implements IContent {
    contentId!: string;
    releaseId?: string;
    version!: string;
    unrealEngineVersion?: string | undefined;
    size!: number;
    isIncludedInCoreArtifact!: boolean;
    isStandalone!: boolean;
    contentType!: string;
    updatedAt!: Date;
    buildData?: string | undefined;

    constructor(data?: IContent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contentId = _data["ContentId"];
            this.releaseId = _data["ReleaseId"];
            this.version = _data["Version"];
            this.unrealEngineVersion = _data["UnrealEngineVersion"];
            this.size = _data["Size"];
            this.isIncludedInCoreArtifact = _data["IsIncludedInCoreArtifact"];
            this.isStandalone = _data["IsStandalone"];
            this.contentType = _data["ContentType"];
            this.updatedAt = _data["UpdatedAt"] ? new Date(_data["UpdatedAt"].toString()) : <any>undefined;
            this.buildData = _data["BuildData"];
        }
    }

    static fromJS(data: any): Content {
        data = typeof data === 'object' ? data : {};
        let result = new Content();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ContentId"] = this.contentId;
        data["ReleaseId"] = this.releaseId;
        data["Version"] = this.version;
        data["UnrealEngineVersion"] = this.unrealEngineVersion;
        data["Size"] = this.size;
        data["IsIncludedInCoreArtifact"] = this.isIncludedInCoreArtifact;
        data["IsStandalone"] = this.isStandalone;
        data["ContentType"] = this.contentType;
        data["UpdatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["BuildData"] = this.buildData;
        return data;
    }
}

export interface IContent {
    contentId: string;
    releaseId?: string;
    version: string;
    unrealEngineVersion?: string | undefined;
    size: number;
    isIncludedInCoreArtifact: boolean;
    isStandalone: boolean;
    contentType: string;
    updatedAt: Date;
    buildData?: string | undefined;
}

export enum ReplayRecordingType {
    Old = "Old",
    New = "New",
    NotAllowed = "NotAllowed",
}

export enum VisibilityType {
    Public = "Public",
    Internal = "Internal",
    Private = "Private",
}

export class ReleaseChannel implements IReleaseChannel {
    releaseChannelId!: string;
    contentMetadataId!: string;
    releaseChannelName!: string;

    constructor(data?: IReleaseChannel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.releaseChannelId = _data["ReleaseChannelId"];
            this.contentMetadataId = _data["ContentMetadataId"];
            this.releaseChannelName = _data["ReleaseChannelName"];
        }
    }

    static fromJS(data: any): ReleaseChannel {
        data = typeof data === 'object' ? data : {};
        let result = new ReleaseChannel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ReleaseChannelId"] = this.releaseChannelId;
        data["ContentMetadataId"] = this.contentMetadataId;
        data["ReleaseChannelName"] = this.releaseChannelName;
        return data;
    }
}

export interface IReleaseChannel {
    releaseChannelId: string;
    contentMetadataId: string;
    releaseChannelName: string;
}

export class ReleaseChannelWithUsersCount extends ReleaseChannel implements IReleaseChannelWithUsersCount {
    usersCount!: number;

    constructor(data?: IReleaseChannelWithUsersCount) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.usersCount = _data["UsersCount"];
        }
    }

    static fromJS(data: any): ReleaseChannelWithUsersCount {
        data = typeof data === 'object' ? data : {};
        let result = new ReleaseChannelWithUsersCount();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["UsersCount"] = this.usersCount;
        super.toJSON(data);
        return data;
    }
}

export interface IReleaseChannelWithUsersCount extends IReleaseChannel {
    usersCount: number;
}

export class ReleaseChannelSearchRequest implements IReleaseChannelSearchRequest {
    pageNumber!: number;
    pageSize!: number;
    releaseChannelIds?: string[] | undefined;
    contentMetadataIds?: string[] | undefined;
    releaseChannelName?: string | undefined;
    includeUsersCount?: boolean | undefined;

    constructor(data?: IReleaseChannelSearchRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.includeUsersCount = false;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["releaseChannelIds"])) {
                this.releaseChannelIds = [] as any;
                for (let item of _data["releaseChannelIds"])
                    this.releaseChannelIds!.push(item);
            }
            if (Array.isArray(_data["contentMetadataIds"])) {
                this.contentMetadataIds = [] as any;
                for (let item of _data["contentMetadataIds"])
                    this.contentMetadataIds!.push(item);
            }
            this.releaseChannelName = _data["releaseChannelName"];
            this.includeUsersCount = _data["includeUsersCount"] !== undefined ? _data["includeUsersCount"] : false;
        }
    }

    static fromJS(data: any): ReleaseChannelSearchRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ReleaseChannelSearchRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.releaseChannelIds)) {
            data["releaseChannelIds"] = [];
            for (let item of this.releaseChannelIds)
                data["releaseChannelIds"].push(item);
        }
        if (Array.isArray(this.contentMetadataIds)) {
            data["contentMetadataIds"] = [];
            for (let item of this.contentMetadataIds)
                data["contentMetadataIds"].push(item);
        }
        data["releaseChannelName"] = this.releaseChannelName;
        data["includeUsersCount"] = this.includeUsersCount;
        return data;
    }
}

export interface IReleaseChannelSearchRequest {
    pageNumber: number;
    pageSize: number;
    releaseChannelIds?: string[] | undefined;
    contentMetadataIds?: string[] | undefined;
    releaseChannelName?: string | undefined;
    includeUsersCount?: boolean | undefined;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

/* tslint:disable */
/* eslint-disable */